import React from "react";

import ShirtImage from "../img/shirt.png";

// Style should contain width + height at least
export default ({style={}, color="#ffffff", children}) => (
    <div style={style}>
        <div style={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            WebkitMask: "url('" + ShirtImage + "') 50% 50% / cover no-repeat",
        }}>
            {children}
        </div>
    </div>
);


// WEBPACK FOOTER //
// ./src/js/TeamShirt.js